import { CURRICULUMS, MODULES, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import ShowModule from "./Show";

export const resources = {
  name: StudentServicePath + MODULES + "/" + CURRICULUMS + "/:id/show",
  title: "Детайли модул",
  custom: <ShowModule />,
  permission: permissions.canPreviewCurriculumModules,
};
